import { FC } from 'react'
import { RouteObject } from 'react-router-dom'
import { authStore } from '@/store/authStore'
import AuditoriaPage from '@/pages/auditoria/AuditoriaPage'
import AuditoriaConsultorPage from '@/pages/auditoria/AuditoriaConsultorPage'

/**
 * Rotas do A17 (Onda 8) — `/auditoria` despachado por papel: ADMIN abre a trilha global
 * (A05, `AuditoriaPage`); consultor (inclusive em onboarding) abre a própria trilha
 * (`AuditoriaConsultorPage`). GERENTE/OPERADOR não têm o item no menu e, se chegarem pela
 * URL, caem na página do consultor, que mostra "sem permissão" com o 403 do backend.
 *
 * O registro anterior de `auditoria` (bloco fixo em `router/index.tsx`, sempre a página
 * do admin) foi removido em favor deste despacho.
 */
const AuditoriaPorPapel: FC = () => {
  const usuario = authStore((s) => s.usuario)
  const ehAdmin = !!usuario?.permissoes?.some((p) => p.toUpperCase() === 'ADMIN')
  return ehAdmin ? <AuditoriaPage /> : <AuditoriaConsultorPage />
}

const rotasA17: RouteObject[] = [{ path: 'auditoria', element: <AuditoriaPorPapel /> }]

export default rotasA17
